import css from 'styled-jsx/css';
import Theme, { colors } from '../../../themes';

const { borderRadius } = Theme.global;

export default css`
  .snippet {
    display: block;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    border-radius: ${borderRadius};
    color: ${colors.grayDark};
    overflow: hidden;
    position: relative;
    margin: 0 8px 8px;
    text-decoration: none;
  }

  .snippet.show-belly {
    margin-bottom: 0;
  }

  .snippet.visited {
    opacity: 0.7;
  }
`;



// WEBPACK FOOTER //
// ./app/common/Snippet/shared/styles.js